// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assistive-status{position:absolute;left:-15px;top:0;z-index:-1;opacity:0}.assistive-status:focus{border:3px solid red}", ""]);
// Exports
module.exports = exports;
